import { writable } from 'svelte/store';

export const newCookbook = writable({
    title: undefined,
    description: undefined
});